/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';

import BoardCass from 'solis/logic/board/cass';

import Countdown from 'solis/claude/element/countdown';
import ProgressStrip from 'solis/react/primitive/progress.strip';


const getScoredText = ({ count, remaining }) =>
{
  const scored = count - Math.ceil(remaining);

  return scored + ' scored';
};


const getNextText = ({ remaining }) =>
{
  const final = Math.ceil(remaining) === 1;

  return final ? 'final in ' : 'next in ';
};


const Caption = (props) =>
(
  <Flex justify = 'between' gap = '3'>
    <Text.Note> {getScoredText(props)} </Text.Note>
    <Text.Note> {getNextText(props)} <Countdown date = {props.nextDate} compact /> </Text.Note>
  </Flex>
);


const Component = ({ count, remaining, nextDate }) =>
(
  <Flex direction = 'column' gap = '1'>

    <ProgressStrip segments = {count} progress = {count - remaining} />
    <Caption count = {count} remaining = {remaining} nextDate = {nextDate} />

  </Flex>
);


export default ({ board, now }) =>
{
  const cass = new BoardCass(board);

  const count = cass.getScoreCount();
  const remaining = cass.getRemainingScoreCount(now);
  const nextDate = cass.getNextScoreDate(now);

  return <Component count = {count} remaining = {remaining} nextDate = {nextDate} />;
};
